import { render, staticRenderFns } from "./photoswipe.vue?vue&type=template&id=faee754c&"
import script from "./photoswipe.vue?vue&type=script&lang=js&"
export * from "./photoswipe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports